import { useState } from "react";
import { NotificationModal } from "./components/NotificationModal";
import { ImportDataModal } from "./components/ImportDataModal";
import { Link, Outlet } from "react-router-dom";
import { NavBar } from "./components/NavBar";
import { PersonalMenu } from "./components/PersonalMenu";
import { TransactionProvider } from "../../app/contexts/TransactionContext";
import usePrivateLayout from "./usePrivateLayout";
import { MobileMenu } from "./components/MobileMenu";
import { DashboardModal } from "../components/DashboardModal";
import { Logo } from "../components/ui/logo";
import { CrefazProvider } from "@/app/contexts/CrefazContext";
import { SalvcarProvider } from "@/app/contexts/SalvcarContext";
import { PanProvider } from "@/app/contexts/PanContext";
import { CrefisaProvider } from "@/app/contexts/CrefisaContext";

function PrivateLayout() {
  const { menus, banner, modalState } = usePrivateLayout();

  const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
  const [isImportDataModalOpen, setIsImportDataModalOpen] = useState(false);

  const handleNotificationMenuClick = () => {
    setIsNotificationModalOpen(true);
  };
  const handleImportData = () => {
    setIsImportDataModalOpen(true);
  };

  return (
    <>
      <DashboardModal banner={banner} {...modalState} />

      <NotificationModal
        isOpen={isNotificationModalOpen}
        onOpenChange={(isOpen: boolean) => setIsNotificationModalOpen(isOpen)}
      />

      <ImportDataModal
        isOpen={isImportDataModalOpen}
        onOpenChange={(isOpen: boolean) => setIsImportDataModalOpen(isOpen)}
      />

      <div className="flex h-screen overflow-hidden">
        <nav className="hidden w-16 bg-white p-5 xs:flex xl:w-60 xl:p-0">
          <div className="flex h-full flex-col justify-between overflow-y-auto ">
            <div className="hidden p-5 xl:block">
              <Link
                to="/transacoes"
                className="flex w-full items-center justify-center py-4"
              >
                <div className="mx-auto flex w-full max-w-[200px] justify-center">
                  <div className="flex h-auto max-h-44 w-full items-center justify-center [&_img]:h-auto [&_img]:max-h-full [&_img]:w-auto [&_img]:max-w-full [&_img]:object-contain">
                    <Logo />
                  </div>
                </div>
              </Link>
              <div className="w-52 border-b-[1px] border-gray01 pt-5" />
              <NavBar menus={menus} />
            </div>
            <PersonalMenu
              handleImportData={handleImportData}
              onNotificationClick={handleNotificationMenuClick}
            />
          </div>
          <div className="hidden xs:block">
            <div className="block xl:hidden ">
              <MobileMenu
                menus={menus}
                onNotificationClick={handleNotificationMenuClick}
                handleImportData={handleImportData}
              />
            </div>
          </div>
        </nav>
        <div className="hidden w-px bg-gray01 xs:block" />
        <main className="flex-grow overflow-y-auto">
          <div className="hidden p-5 max-xs:block">
            <MobileMenu
              menus={menus}
              onNotificationClick={handleNotificationMenuClick}
              handleImportData={handleImportData}
            />
          </div>
          <div className="hidden border-b-[1px] border-gray01 max-xs:block" />
          <div className="h-full px-6 pt-5">
            <TransactionProvider>
              <CrefazProvider>
                <SalvcarProvider>
                  <PanProvider>
                    <CrefisaProvider>
                      <Outlet />
                    </CrefisaProvider>
                  </PanProvider>
                </SalvcarProvider>
              </CrefazProvider>
            </TransactionProvider>
          </div>
        </main>
      </div>
    </>
  );
}

export default PrivateLayout;
